<h1  class="stepheading">Confirm Delete?</h1>
<mat-divider></mat-divider>
<div class="modalbody">
    <div  >
        <div class="textsection">
           Are you sure want to delete this {{data.from}}?
          </div>
    </div>
</div>

<div mat-dialog-actions style="display: flex;gap:5px;padding: 5px;">
    <button
    (click)="cancelOrder()"
      class="okbtn"
      mat-button
      mat-dialog-close
      style="background-color: white"
    >
      Cancel
    </button>
    <button
    class="okbtn"
    mat-button
    (click)="approveOrder()"
    style="background-color: #f7665e;color:#fff"
  >
    Yes
  </button>

</div>